import Constant from "../constants";
import Cookies from "js-cookie";

async function futch(url, opts = {}, onProgress) {
  console.log(url, opts);
  return new Promise((res, rej) => {
    var xhr = new XMLHttpRequest();
    xhr.open(opts.method || "get", url);
    for (var k in opts.headers || {}) xhr.setRequestHeader(k, opts.headers[k]);
    xhr.onload = (e) => res(e.target);
    xhr.onerror = rej;
    if (xhr.upload && onProgress) xhr.upload.onprogress = onProgress; // event.loaded / event.total * 100 ; //event.lengthComputable
    xhr.send(opts.body);
  });
}

async function fetchAPI({
  method,
  uri,
  body,
  success,
  error,
  serviceBaseUrl,
  useRefreshToken = false,
}) {
  let headers = {
    Accept: "*/*",
    "Access-Control-Allow-Origin": "*",
  };
  if (body instanceof FormData) {
    headers = {};
  } else {
    headers["Content-Type"] = "application/json";
  }

  if (!method) {
    method = "get";
  }
  // Build complete API url
  // If service URL is specified, use it, otherwise use default API url
  let apiUrl = "";
  if (serviceBaseUrl) {
    apiUrl = serviceBaseUrl + uri;
  } else {
    apiUrl = Constant.apiBaseUrl + uri;
  }

  console.log("Calling api " + apiUrl);

  // Get access token and attach it to API request's header
  let access_token = Cookies.get("access_token");
  if (access_token != null) {
    if (useRefreshToken == true) {
      access_token = Cookies.get("refresh_token");
    }
    headers["Authorization"] = `Bearer ${access_token}`;
  } else {
    console.log("No token is stored");
  }

  // Construct fetch options
  let fetchOptions = { method, headers };

  console.log(fetchOptions);

  // Only add fetch body when method is PUT or POST
  if (
    method.toLowerCase() === "post" ||
    method.toLowerCase() === "put" ||
    method.toLowerCase() === "delete"
  ) {
    if (body instanceof FormData) {
      fetchOptions.body = body;
    } else {
      if (body) {
        fetchOptions.body = JSON.stringify(body);
      }
    }
  }
  // Run the fetching
  return fetch(apiUrl, fetchOptions)
    .then((responseJson) => responseJson.json())
    .then((response) => success(response))
    .catch((errorMessage) => {
      if (errorMessage) {
        if (error) {
          error(errorMessage);
          // alert('Đã xảy ra lỗi khi xử lý API');
        }
      } else {
        console.error(errorMessage);
        // alert('Đã xảy ra lỗi khi xử lý API');
      }
    });
}

function getAccessToken() {
  const accessToken = Cookies.get("access_token");
  return accessToken;
}

function getCurrentUser() {
  const user = Cookies.get("user");
  if (user) {
    return JSON.parse(user);
  } else {
    return user
  };
}

function getCurrentCompanyId() {
  const companyId = Cookies.get("company_id");
  return companyId;
}

export default {
  fetchAPI: fetchAPI,
  futch: futch,
  getAccessToken,
  getCurrentUser,
  getCurrentCompanyId,
};
